import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_BASE = API;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("caa_access_token");
  if (token && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Auto-clear a stale/expired token on 401 so a corrupt localStorage entry
// from a previous session never blocks a fresh login. We only clear on
// authenticated requests (Bearer header present) — an anonymous /auth/me
// probe returning 401 is expected and must NOT trigger a clear.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const hadAuth = !!err?.config?.headers?.Authorization;
    if (status === 401 && hadAuth) {
      localStorage.removeItem("caa_access_token");
    }
    return Promise.reject(err);
  },
);

export const http = api;
export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return "$" + Number(n).toLocaleString("en-AU", { maximumFractionDigits: 0 });
}

export function formatNumber(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-AU");
}

export function timeFromNow(iso) {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  const diff = t - Date.now();
  const abs = Math.abs(diff);
  const mins = Math.floor(abs / 60000);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);
  const label =
    days > 0 ? `${days}d ${hours % 24}h` : hours > 0 ? `${hours}h ${mins % 60}m` : `${mins}m`;
  return diff < 0 ? `${label} ago` : `in ${label}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}

export function sourceLabel(key) {
  return (
    {
      pickles: "Pickles",
      slattery: "Slattery",
      ross: "Ross",
      ritchiebros: "Ritchie Bros",
      manual: "Manual",
    }[key] || key
  );
}
